import { createElement } from 'react';

interface FormaHeaderProps extends React.HTMLAttributes<HTMLElement> {
	variant?: 'primary' | 'secondary' | 'tertiary' | 'project-header';
	className?: string;
}

export function FormaHeader({ children, variant, className }: FormaHeaderProps) {
	return createElement('forma-header', { variant: variant ?? 'primary', className }, children);
}
